import React, { CSSProperties } from 'react';
import Loader from 'react-spinners/ClimbingBoxLoader';

const override: CSSProperties = {
  position: `absolute`,
  left: '50%',
  top: '25%',
  zIndex: `1000`,
  width: `150px`,
  height: `150px`,
  margin: `-75px 0 0 -75px`,
  backgroundColor: `#777777`,
  opacity: `0.5`,
  borderRadius: `10px`,
};

function FormLoader({ isLoading }: { isLoading: boolean }) {
  return <Loader cssOverride={override} size={25} color="#FFF" loading={isLoading} />;
}

export default FormLoader;
